import type {AxiosRequestConfig} from 'axios';
import {Supervisors} from './interface';

export class GetAllAgenciesRequestBuilder {
  private readonly request: AxiosRequestConfig = {
    method: 'GET',
    url: '/agencies',
    params: {},
  };

  params(params: object) {
    this.request.params = params;
    return this;
  }

  build() {
    return this.request;
  }
}
